import { type ShelfViewAllProps } from '@/features/shop/components/Shelf'

type GetShelfViewAllParams = {
  viewAllHref?: string | null
  onViewAll: () => void | Promise<unknown>
}

export const getShelfViewAll = ({
  viewAllHref,
  onViewAll,
}: GetShelfViewAllParams): ShelfViewAllProps => (viewAllHref ? { onViewAll, viewAllHref } : {})
